export default "__VITE_ASSET__D4asb3jH__"